document.addEventListener('DOMContentLoaded', function () {
  const subnavLinks = document.querySelectorAll('.proxy-subnav a');
  const secondaryNavLinks = document.querySelectorAll(
    '.secondary-nav .list-menu .header__menu-item[data-link-text="menu:level2"], .secondary-nav .mega-menu__link[data-link-text="menu:level4:groupedLinks"], .secondary-nav .mega-menu__link[data-link-text="menu:level3:groupedLinks"]'
  );
  const megaMenuQuickLinks = document.querySelectorAll(
    '.secondary-nav .mega-menu__link[data-link-text="menu:level3:quickLinks"], .secondary-nav .mega-menu__link[data-link-text="menu:level3:featuredLinks"]'
  );

  // Function to get breadcrumb data
  function getBreadcrumbData() {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
    const breadcrumbs = [];

    breadcrumbItems.forEach((item) => {
      const url = item.getAttribute('href');
      const text = item.textContent.trim();
      if (url && text && url !== '/') {
        // Skip home link
        breadcrumbs.push({
          url: url,
          text: text,
          handle: text
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, ''),
        });
      }
    });
    return breadcrumbs;
  }

  // Function to highlight menu items based on breadcrumbs
  function highlightFromBreadcrumbs() {
    const breadcrumbs = getBreadcrumbData();
    if (breadcrumbs.length === 0) return false; // Return false if no breadcrumbs found

    breadcrumbs.forEach((breadcrumb) => {
      // Check secondary nav links for matching URLs or handles
      secondaryNavLinks.forEach((link) => {
        const linkUrl = link.getAttribute('href');
        const linkText = link.textContent.trim();
        const linkSpan = link.querySelector('span');

        // Match by URL or text content
        if (linkUrl && linkText.toLowerCase() === breadcrumb.text.toLowerCase() && linkUrl === breadcrumb.url) {
          // Highlight the link
          const linkSpan = link.querySelector('span');
          if (linkSpan) {
            linkSpan.classList.add('header__active-menu-item');
          } else {
            link.classList.add('mega-menu__link--active');
          }

          // Highlight parent menu items
          highlightParentMenus(link);
        }
      });

      // Also check mega menu quick links
      megaMenuQuickLinks.forEach((link) => {
        const linkUrl = link.getAttribute('href');
        const linkText = link.textContent.trim();
        if (linkUrl && linkText.toLowerCase() === breadcrumb.text.toLowerCase()) {
          link.classList.add('mega-menu__link--active');
          highlightParentMenus(link);
        }
      });
    });

    return true; // Return true if breadcrumbs were processed
  }

  function waitForBreadcrumbs(callback, maxAttempts = 20, attempt = 1) {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');

    if (breadcrumbItems.length > 0) {
      callback();
    } else if (attempt < maxAttempts) {
      setTimeout(() => {
        waitForBreadcrumbs(callback, maxAttempts, attempt + 1);
      }, 250);
    } else {
      callback();
    }
  }

  function observeBreadcrumbs(callback) {
    const breadcrumbContainer = document.querySelector('.breadcrumb, nav[aria-label*="breadcrumb"], .breadcrumbs');

    if (!breadcrumbContainer) {
      waitForBreadcrumbs(callback);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          const breadcrumbItems = document.querySelectorAll('.breadcrumb__item a');
          if (breadcrumbItems.length > 0) {
            observer.disconnect();
            callback();
          }
        }
      });
    });

    observer.observe(breadcrumbContainer, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      observer.disconnect();
      callback();
    }, 5000); // 5 second timeout
  }

  // Function to highlight parent menu items
  function highlightParentMenus(link) {
    // Find the parent secondary nav container
    const secondaryNavContainer = link.closest('.secondary-nav .list-menu');
    if (secondaryNavContainer) {
      const parentHandle = secondaryNavContainer.getAttribute('data-parent');
      if (parentHandle) {
        // Highlight the primary nav item
        document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
          if (item.getAttribute('data-id') === parentHandle) {
            const span = item.querySelector('span');
            if (span) {
              span.classList.add('header__active-menu-item');
            }
          }
        });
      }
    }

    // If it's a mega menu link, also highlight the secondary nav parent
    const megaMenuList = link.closest('.mega-menu__list');
    if (megaMenuList) {
      const parentHandle = megaMenuList.getAttribute('data-parent');
      if (parentHandle) {
        // Find and highlight the secondary nav parent
        const parentSecondaryLink = document.querySelector(
          `.secondary-nav .header__menu-item[href*="menu=${parentHandle}"]`
        );
        if (parentSecondaryLink) {
          const span = parentSecondaryLink.querySelector('span');
          if (span) {
            span.classList.add('header__active-menu-item');
          }
        }

        // Highlight the primary nav item
        document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
          if (item.getAttribute('data-id') === parentHandle) {
            const span = item.querySelector('span');
            if (span) {
              span.classList.add('header__active-menu-item');
            }
          }
        });
      }
    }
  }

  // Main function to handle all navigation highlighting
  function handleNavigationHighlighting() {
    subnavLinks.forEach((link) => {
      if (link.classList.contains('active')) {
        let linkParent = link.closest('.proxy-subnav').getAttribute('data-parent');
        if (linkParent) {
          document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
            if (item.getAttribute('data-id') === linkParent) {
              item.querySelector('span').classList.add('header__active-menu-item');
            }
          });
        }
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    const clickedMenu = urlParams.get('menu');
    const clickedSubmenu = urlParams.get('submenu');

    if (clickedSubmenu) {
      secondaryNavLinks.forEach((link) => {
        if (link.getAttribute('data-link-text') !== 'menu:level2') {
          const linkUrl = new URL(link.href, window.location.origin);
          const linkParam = linkUrl.searchParams.get('submenu');
          if (linkParam != clickedSubmenu) {
            link.classList.remove('mega-menu__link--active');
          }
        }
      });
      sessionStorage.setItem('activeSubMenu', clickedSubmenu);
    }

    const activeSubMenu = sessionStorage.getItem('activeSubMenu');
    if (!clickedSubmenu && activeSubMenu) {
      secondaryNavLinks.forEach((link) => {
        if (link.getAttribute('data-link-text') !== 'menu:level2') {
          const linkHandle = handleize(link.textContent.trim());
          if (linkHandle === activeSubMenu) {
            link.classList.add('mega-menu__link--active');
          } else {
            link.classList.remove('mega-menu__link--active');
          }
        }
      });
    }

    if (clickedMenu) {
      secondaryNavLinks.forEach((link) => {
        const linkUrl = new URL(link.href, window.location.origin);
        const linkParam = linkUrl.searchParams.get('menu');
        let linkSpan = link.querySelector('span');

        if (linkParam === clickedMenu) {
          if (linkSpan) {
            linkSpan.classList.add('header__active-menu-item');
            let linkSpanParent = link.closest('.secondary-nav .list-menu')?.getAttribute('data-parent');
            if (linkSpanParent) {
              document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
                if (item.getAttribute('data-id') === linkSpanParent) {
                  item.querySelector('span')?.classList.add('header__active-menu-item');
                }
              });
            }
            if (link.getAttribute('data-link-text') === 'menu:level2') {
              sessionStorage.setItem('activeMenu', handleize(linkSpan.textContent.trim()));
            } else {
              sessionStorage.removeItem('activeMenu');
            }
          }
          megaMenuQuickLinks.forEach((link) => {
            if (link) {
              link.classList.remove('mega-menu__link--active');
            }
          });
        } else {
          if (linkSpan) {
            linkSpan.classList.remove('header__active-menu-item');
          } else if (link) {
            link.classList.remove('mega-menu__link--active');
          }
        }
      });
    } else {
      // If no URL parameters, check breadcrumbs and existing active states
      secondaryNavLinks.forEach((link) => {
        let linkSpan = link.querySelector('span') || link;
        if (linkSpan.classList.contains('header__active-menu-item')) {
          let linkSpanParent = link.closest('.secondary-nav .list-menu')?.getAttribute('data-parent');
          if (linkSpanParent) {
            document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
              if (item.getAttribute('data-id') === linkSpanParent) {
                item.querySelector('span')?.classList.add('header__active-menu-item');
              }
            });
          }
          megaMenuQuickLinks.forEach((link) => {
            if (link) {
              link.classList.remove('mega-menu__link--active');
            }
          });
        }
        if (
          link.getAttribute('data-link-text') === 'menu:level2' ||
          link.getAttribute('data-link-text') === 'menu:level1' ||
          link.getAttribute('data-link-text') === 'menu:level3:groupedLinks'
        ) {
          sessionStorage.removeItem('activeSubMenu');
        }
        const activeMenu = sessionStorage.getItem('activeMenu');
        if (link.getAttribute('data-link-text') === 'menu:level2' && activeMenu) {
          if (handleize(link.textContent.trim()) === activeMenu) {
            linkSpan.classList.add('header__active-menu-item');
            link.classList.remove('mega-menu__link--active');
          } else {
            linkSpan.classList.remove('header__active-menu-item');
          }
        }
      });

      // Apply breadcrumb-based highlighting when no URL parameters
      highlightFromBreadcrumbs();
    }
    megaMenuQuickLinks.forEach((link) => {
      if (link.classList.contains('mega-menu__link--active')) {
        let linkParent = link.closest('.secondary-nav .mega-menu__list').getAttribute('data-parent');
        if (linkParent) {
          document.querySelectorAll('.header__menu-item[data-link-text="menu:level1"]').forEach((item) => {
            if (item.getAttribute('data-id') === linkParent) {
              item.querySelector('span').classList.add('header__active-menu-item');
            }
          });
        }
      }
    });

    // Clean up URL parameters
    // window.history.replaceState({}, document.title, window.location.pathname);
    const url = new URL(window.location);
    url.searchParams.delete('menu');
    url.searchParams.delete('submenu');
    window.history.replaceState({}, document.title, url.toString());
  }
  observeBreadcrumbs(handleNavigationHighlighting);

  window.addEventListener('pageshow', function (event) {
    handleNavigationHighlighting();
    sessionStorage.removeItem('activeMenu');
  });

  function handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-') // replace spaces & special chars with -
      .replace(/^-+|-+$/g, ''); // trim leading/trailing -
  }
});
